export const antiCheatData = {
  backgroundUrl: "/backgrounds/bg_art_train.jpg",
  title: "Akros Anti-Cheat",
  description: `Para jugar en ESGPLAY necesitas descargar Akros Anti-Cheat (AAC). Este software se puede descargar a través del siguiente link. No podrás ingresar a los servidores si no tienes descargado, instalado y ejecutado el anti-cheat`,
  installation: {
    title: "Guía de instalación",
    downloadLink: "https://akros.ac/setup.exe",
    bulletPoints: [
      `Descargue e instale el cliente oficial de Akros Anti-Cheat.`,
      `Inicie el cliente Akros Anti-Cheat`,
      `Inicie Counter-Strike: Global Offensive y conéctese al servidor del juego.`,
    ],
    images: [
      {
        source: "/icons/akros_ac.png",
        title: "Akros Anti-Cheat",
      },
    ],
    important: `* Debe tener el Akros Anti-Cheat siempre corriendo antes de ingresar a los servidores de ESGPLAY.`,
  },
  recomendations: `Se debe tener en cuenta que su sistema operativo Windows 10 o Windows 11 debe estar actualizado a la última versión, en caso no lo sepas intenta actualización de sistema. Si no tienes actualizado tu sistema operativo podrías ser kickeado de manera automática del servidor.`,
};
